import React, { useState } from "react"
import DynamicExperianFields from "../DynamicExperianFields"
import ModalComponent from "../../../../components/Modal/Modal"
import { PlusIcon } from "../../../../components/Icons/Icons"
import { useMyContextLoading } from "../../../../components/LoadingContextProvider/LoadingContextProvider"
import { useDispatch } from "react-redux"
import { saveCreditProfile } from "../../../../features/creditReports/creditReports"
import { showSnackBar } from "../../../../components/Snackbar/Snackbar"
import { MISSING_FIELDS_MESSAGE, NOTHING_SAVED_MESSAGE, hasBlockingErrors, withAmountDefaults } from "./helper"

const AddDebtManual = ({
                         fields,
                         errors,
                         setFields,
                         setErrors,
                         reportId,
                         userId,
                         initialFieldSet,
                         update,
                         setUpdate,
                         showFieldErrors = false,
                         rules = null,
                       }) => {
  const {triggerLoading} = useMyContextLoading()
  const dispatch = useDispatch()
  const [revealErrors, setRevealErrors] = useState(false)
  const [triggerCloseModal, setTriggerCloseModal] = useState(false)

  const createDebts = async () => {
    if (showFieldErrors && hasBlockingErrors(errors)) {
      setRevealErrors(true)
      showSnackBar("error", MISSING_FIELDS_MESSAGE)
      return
    }

    triggerLoading(true)
    try {
      const response = await dispatch(saveCreditProfile({
        userId,
        data: fields?.map(field => withAmountDefaults({...field, creditReport: reportId}))
      }))

      const saved = response?.payload?.data

      if (response?.error) {
        showSnackBar("error", response?.payload || response?.error)
      } else if (Array.isArray(saved) && saved.length === 0) {
        showSnackBar("error", NOTHING_SAVED_MESSAGE)
      } else if (saved) {
        setUpdate(!update)
        setFields([])
        setRevealErrors(false)
        setTriggerCloseModal(prev => !prev)
      }
    } catch (error) {
      showSnackBar("error", error)
    }
    triggerLoading(false)
  }

  return (
    <ModalComponent
      modalButtonTitle="Save"
      buttonType="outlined"
      buttonTitleStyle="flex justify-center"
      title="Create Debts"
      functionButton={() => createDebts()}
      customScroll={true}
      disableCloseFunctionButton={showFieldErrors}
      triggerCloseModal={triggerCloseModal}
      disabled={showFieldErrors ? false : errors?.some((err) => Object.keys(err).length > 0)}
      buttonTitle={
        <span className="flex items-center gap-2 whitespace-nowrap">
          <PlusIcon fill="currentColor" />
          Add Credit Line
        </span>
      }
    >
      <DynamicExperianFields
        setFields={setFields}
        fields={fields}
        errors={errors}
        setErrors={setErrors}
        initialFieldSet={initialFieldSet}
        showFieldErrors={showFieldErrors}
        revealErrors={revealErrors}
        rules={rules}
      />
    </ModalComponent>
  )
}

export default AddDebtManual
